$(function() {
  setTimeout(function() {
    $('#customer_login > div.ndnapps-sociallogin-wrapper > span').css('display', 'none');
  }, 1000);

  $('.cb-icon-search').on('click', function(){
    $('.mobile-menu a[href="#menu"]').click();
    $('input[type="search"]').focus();
  });
});

/**
 * 360WHEELS: on Color (or featured-image) change, smoothly jump the product
 * photo/gallery back to the top of the viewport under the sticky header.
 * District StyleHatch fires variantImageChange only when featured image src
 * changes; Color swatch/radio listeners force scroll even if that event name
 * or media key detection misses.
 */
(function () {
  var HEADER_OFFSET = 72;
  var scrollTimer = null;
  var lastMediaKey = null;
  var lastColorValue = null;
  var FORCE_REASONS = {
    colorOption: true,
    variantImageChange: true,
    variantChangeColor: true
  };

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.getAttribute('data-template') === 'product') return true;
    if ((document.body.className || '').indexOf('template-product') !== -1) return true;
    return !!document.querySelector(
      '[data-section-type="product-template"], [data-ProductSection], .product-template'
    );
  }

  function galleryEl() {
    return (
      document.querySelector('.product-images') ||
      document.querySelector('#ProductPhoto-product-template') ||
      document.querySelector('[data-ProductPhoto]') ||
      document.querySelector('.images-container') ||
      document.querySelector('.product-image--slider')
    );
  }

  function headerOffset() {
    var header =
      document.querySelector('.site-header') ||
      document.querySelector('.site-header-wrapper') ||
      document.querySelector('header[role="banner"]');
    if (!header) return HEADER_OFFSET;
    var h = Math.round(header.getBoundingClientRect().height);
    if (!h || h < 40) return HEADER_OFFSET;
    return Math.min(Math.max(h, 56), 120);
  }

  function featuredMediaKey() {
    var selected =
      document.querySelector('.product-image--slider .product-image--cell.is-selected') ||
      document.querySelector('.product-image--slider .is-selected[data-image-id]') ||
      document.querySelector('.product-image--cell.is-selected');
    if (selected && selected.getAttribute('data-image-id')) {
      return selected.getAttribute('data-image-id');
    }
    var photo = document.querySelector('[data-ProductPhoto]');
    var img =
      (photo && photo.querySelector('img')) ||
      document.querySelector('.product-image--slider .is-selected img') ||
      document.querySelector('.product-image--slider img');
    if (!img) return null;
    return (
      img.getAttribute('data-id') ||
      img.getAttribute('data-image-id') ||
      img.currentSrc ||
      img.src ||
      null
    );
  }

  function currentColorValue() {
    var checked =
      document.querySelector(
        'fieldset[name="Color"] input[type="radio"]:checked, input[type="radio"][name="Color"]:checked'
      ) ||
      document.querySelector(
        '.single-option-radio[name="Color"] input:checked, input.single-option-selector__radio[name="Color"]:checked'
      );
    if (checked) return checked.value || null;
    var label = document.querySelector(
      'label[for="SingleOptionRadioSelector-option-2"] .single-option-radio__label--value'
    );
    return label ? (label.textContent || '').trim() || null : null;
  }

  function scrollGalleryIntoView(force) {
    var el = galleryEl();
    if (!el) return;
    var offset = headerOffset();
    var rect = el.getBoundingClientRect();
    var top = window.pageYOffset + rect.top - offset;
    if (top < 0) top = 0;
    var delta = Math.abs(window.pageYOffset - top);
    // Only skip when already parked on the gallery top (unless forced by Color)
    if (!force && delta < 10) return;
    try {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  function runScroll(reason) {
    var force = !!FORCE_REASONS[reason];
    var key = featuredMediaKey();
    if (key) lastMediaKey = key;
    // Double rAF waits for District _updateImages / Flickity cell swap
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollGalleryIntoView(force);
        // Second pass after lazyload/src swap settles
        setTimeout(function () {
          scrollGalleryIntoView(force);
        }, 120);
      });
    });
  }

  function scheduleScroll(reason) {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      var key = featuredMediaKey();
      if (
        !FORCE_REASONS[reason] &&
        key &&
        key === lastMediaKey &&
        reason !== 'variantImageChange'
      ) {
        return;
      }
      runScroll(reason);
    }, 40);
  }

  function onVariantImageChange() {
    scheduleScroll('variantImageChange');
  }

  function onVariantChange() {
    var color = currentColorValue();
    if (color && color !== lastColorValue) {
      lastColorValue = color;
      scheduleScroll('variantChangeColor');
      return;
    }
    // Featured image may still change without Color string change (e.g. Size+image)
    scheduleScroll('variantChange');
  }

  function onColorOptionChange() {
    var color = currentColorValue();
    if (color) lastColorValue = color;
    scheduleScroll('colorOption');
  }

  function bindJquery() {
    var $ = window.jQuery || window.$;
    if (!$ || !$.fn) return false;
    var sectionSel =
      '[data-ProductSection], .product-template, [data-section-type="product-template"]';

    $(document)
      .off('variantImageChange.360wheelsGalleryScroll')
      .on('variantImageChange.360wheelsGalleryScroll', sectionSel, onVariantImageChange)
      .off('variantChange.360wheelsGalleryScroll')
      .on('variantChange.360wheelsGalleryScroll', sectionSel, onVariantChange);

    $(sectionSel).each(function () {
      $(this)
        .off('variantImageChange.360wheelsGalleryScroll')
        .on('variantImageChange.360wheelsGalleryScroll', onVariantImageChange)
        .off('variantChange.360wheelsGalleryScroll')
        .on('variantChange.360wheelsGalleryScroll', onVariantChange);
    });

    // Color radios / swatches (District option name="Color")
    $(document)
      .off('change.360wheelsGalleryScrollColor')
      .on(
        'change.360wheelsGalleryScrollColor',
        'input[type="radio"][name="Color"], fieldset[name="Color"] input[type="radio"], .single-option-radio[name="Color"] input[type="radio"]',
        onColorOptionChange
      )
      .off('click.360wheelsGalleryScrollColor')
      .on(
        'click.360wheelsGalleryScrollColor',
        'fieldset[name="Color"] .swatch-label--color, fieldset[name="Color"] label.swatch-label--color, .single-option-radio[name="Color"] label',
        function () {
          // Click fires before :checked updates in some browsers — defer
          setTimeout(onColorOptionChange, 0);
        }
      );

    return true;
  }

  function bindNativeFallback() {
    document.addEventListener(
      'change',
      function (evt) {
        var t = evt.target;
        if (!t || !t.getAttribute) return;
        if (t.getAttribute('name') === 'Color' && t.matches && t.matches('input[type="radio"]')) {
          onColorOptionChange();
        }
      },
      true
    );
  }

  function bindMediaObserver() {
    var root =
      document.querySelector('[data-ProductPhoto]') ||
      document.querySelector('.product-image--slider') ||
      document.querySelector('.product-images');
    if (!root || typeof MutationObserver === 'undefined') return;
    lastMediaKey = featuredMediaKey();
    var obs = new MutationObserver(function () {
      var key = featuredMediaKey();
      if (!key || key === lastMediaKey) return;
      lastMediaKey = key;
      scheduleScroll('mediaMutation');
    });
    obs.observe(root, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'src', 'srcset', 'data-src', 'data-image-id'],
      subtree: true,
      childList: true
    });
  }

  function init() {
    if (!isProductPage()) return;
    lastColorValue = currentColorValue();
    lastMediaKey = featuredMediaKey();
    bindJquery();
    bindNativeFallback();
    setTimeout(bindJquery, 400);
    setTimeout(bindJquery, 1200);
    setTimeout(bindMediaObserver, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * 360WHEELS (2026-11-04): currency code on every price + SALE badge/label sync.
 * - Normalises every span.money to "CODE $amount" (e.g. "HKD $70,000",
 *   "USD $9,000", "EUR €8,000"), including prices re-rendered by theme.js on
 *   variant change and by the currency converter (jquery.currencies).
 * - Shows/hides the product-page SALE badge + label when the variant changes
 *   (follows the theme's #ComparePrice visibility).
 */
(function () {
  var CODE_RE = /^[A-Z]{3}$/;
  function currentCode() {
    try { if (window.Currency && Currency.currentCurrency) return Currency.currentCurrency; } catch (e) {}
    var sel = document.querySelector('select.currency-picker');
    if (sel && sel.value) return sel.value;
    return (window.StyleHatch && StyleHatch.shopCurrency) || 'HKD';
  }
  function normalise(el) {
    if (el.querySelector('span.money')) return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t || !/\d/.test(t)) return;
    var code = null, m;
    if ((m = t.match(/\s([A-Z]{3})$/))) { code = m[1]; t = t.slice(0, -4).trim(); }
    if ((m = t.match(/^([A-Z]{3})\s/))) { code = code || m[1]; t = t.slice(4).trim(); }
    if (!code || !CODE_RE.test(code)) code = currentCode();
    t = t.replace(/^(HK|US|C|A|NZ|S)(?=\$)/, '');
    var out = code + ' ' + t;
    if (el.textContent !== out) el.textContent = out;
  }
  function run() {
    var list = document.querySelectorAll('span.money');
    for (var i = 0; i < list.length; i++) normalise(list[i]);
    syncSale();
  }
  function syncSale() {
    var cmp = document.querySelector('[data-ComparePrice]');
    if (!cmp) return;
    var on = cmp.style.display !== 'none' && getComputedStyle(cmp).display !== 'none';
    var els = document.querySelectorAll('[data-rw-sale-badge],[data-rw-sale-label]');
    var want = on ? '' : 'none';
    for (var i = 0; i < els.length; i++) if (els[i].style.display !== want) els[i].style.display = want;
  }
  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; run(); });
  }
  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['style']
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('currency-picker')) setTimeout(run, 50);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
